import moment from "moment";

import { Card, Header, List } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Flex from "../../../../../components/Flex/Flex";
import CardContentExpandButton from "../../../../ui/components/CardContentExpandButton/CardContentExpandButton";
import Label from "../../../../ui/components/Label/Label";

export default function WhatsNewRelease({ release, latest }) {
	const { t } = useTranslation();
	const { version, date, beta, features, fixes } = release;

	const [showFixes, setShowFixes] = useState(features.length === 0);

	return (
		<>
			<Card fluid style={{ marginBottom: 20 }}>
				<Card.Content>
					<Flex alignItems="center">
						<Header as="h3" style={{ margin: 0 }}>
							{version}
							<Header.Subheader>{moment(date).format("LL")}</Header.Subheader>
						</Header>

						<Flex width="auto" gap={5}>
							{latest && <Label color="blue">{t("whatsNewLatest", "Latest")}</Label>}
							{beta && <Label color="orange">{t("whatsNewBeta", "Beta")}</Label>}
						</Flex>
					</Flex>
				</Card.Content>
				{features.length > 0 && (
					<Card.Content>
						<List relaxed bulleted>
							{features.map((feature) => (
								<List.Item key={feature} content={feature} />
							))}
						</List>
					</Card.Content>
				)}

				{fixes.length > 0 && (
					<Card.Content
						onClick={() => setShowFixes((showFixes) => !showFixes)}
						style={{ cursor: "pointer", color: "var(--color-text-muted)" }}
					>
						{showFixes ? (
							<List relaxed bulleted>
								{fixes.map((fix) => (
									<List.Item key={fix} content={fix} />
								))}
							</List>
						) : (
							`${t("otherFixes", "Other fixes")} (${fixes.length})`
						)}
					</Card.Content>
				)}
			</Card>
		</>
	);
}
